/* Shopify owns the discount and first-order eligibility; this script only handles presentation. */
(() => {
  if (window.WotfWelcomeOffer) return;
  const script = document.querySelector('[data-welcome-controller]');
  const cartUrl = script?.dataset.cartUrl || '/cart';
  const endpoint = cartUrl.replace(/\/$/, '');
  const root = document.querySelector('[data-welcome-offer]');
  const preview = root?.dataset.preview === 'true';
  const welcomeCode = 'WELCOME10';
  const codePattern = /^WELCOME10$/i;
  let activeCode = '', pending = null, appliedCart = null;
  const readCode = () => { if (activeCode) return activeCode; try { return sessionStorage.getItem('wotf:welcome-code') || ''; } catch { return ''; } };
  const saveCode = code => { activeCode = code; try { sessionStorage.setItem('wotf:welcome-code', code); } catch {} };
  function discounts(cart) {
    const lineSavings = Math.max(0, cart.original_total_price - cart.items_subtotal_price);
    return { original: cart.original_total_price, lineSavings, applications: cart.cart_level_discount_applications || [], saved: cart.total_discount, total: cart.total_price };
  }
  function isWelcome(cart) {
    return cart.total_discount > 0 && (cart.cart_level_discount_applications || []).some(d =>
      /^WELCOME10$/i.test(d.title || '') || d.title === 'First Order Welcome · 10% Off');
  }
  async function fetchCart() {
    const response = await fetch(endpoint + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw Error('Your cart could not be checked.');
    return response.json();
  }
  async function applyWelcome(cart) {
    const code = readCode();
    if (preview || !codePattern.test(code)) return null;
    if (pending) return pending;
    pending = (async () => {
      const current = cart || await fetchCart();
      if (!current.items?.length || isWelcome(current) || current.total_discount > 0) return current;
      const key = current.token + ':' + current.original_total_price + ':' + current.item_count + ':' + code;
      if (key === appliedCart) return current;
      appliedCart = key;
      const editor = document.querySelector('cart-editor');
      if (editor?.busy || window.TotfCart?.isBusy?.()) { appliedCart = null; return current; }
      if (typeof editor?.update === 'function') {
        await editor.update({ discount: code }, null, 'discount');
        return null;
      }
      const response = await fetch(endpoint + '/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: code }),
      });
      if (!response.ok) throw Error('Your coupon could not be checked.');
      const updated = await response.json();
      if (document.querySelector('#TotfCart[open]')) await window.TotfCart?.reload?.();
      return updated;
    })().catch(() => { appliedCart = null; return null; }).finally(() => { pending = null; });
    return pending;
  }
  const claimedCode = () => {
    let confirmedSignup = false;
    try { confirmedSignup = localStorage.getItem('wotf:welcome10:subscribed') === 'true'; } catch {}
    const savedCode = readCode();
    if (codePattern.test(savedCode)) return savedCode;
    return confirmedSignup ? welcomeCode : '';
  };
  window.WotfWelcomeOffer = { applyWelcome, claimedCode, discounts, isWelcome };
  // Preserve the existing email-link path without issuing a code in the browser.
  const params = new URLSearchParams(location.search);
  const incoming = params.get('welcome_code');
  if (!preview && codePattern.test(incoming || '')) {
    saveCode(incoming);
    params.delete('welcome_code');
    history.replaceState(history.state, '', location.pathname + (params.size ? '?' + params.toString() : '') + location.hash);
  }
  if (!preview && readCode()) applyWelcome();
  document.addEventListener('totf:cart-updated', event => { if (!pending) applyWelcome(event.detail?.cart); });
  if (!root) return;

  const dialog = root.querySelector('dialog');
  const launcher = root.querySelector('[data-offer-open]');
  const form = root.querySelector('form');
  const submitButton = form.querySelector('[type=submit]');
  const succeeded = !!root.querySelector('[data-offer-subscribed]');
  const failed = !!root.querySelector('[data-offer-error]');
  const cooldownKey = 'wotf:welcome10:dismiss-until';
  const subscribedKey = 'wotf:welcome10:subscribed';
  const dwellKey = 'wotf:welcome10:visible-ms';
  const shownKey = 'wotf:welcome10:shown';
  const readLocal = key => { try { return localStorage.getItem(key); } catch { return null; } };
  const writeLocal = (key, value) => { try { localStorage.setItem(key, String(value)); } catch {} };
  const readSession = key => { try { return sessionStorage.getItem(key); } catch { return null; } };
  const writeSession = (key, value) => { try { sessionStorage.setItem(key, String(value)); } catch {} };
  const visible = el => !!el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden';
  const unfinishedTool = () => {
    const free = document.querySelector('[data-free-tarot]');
    const celtic = document.querySelector('[data-celtic-cross]');
    const iching = document.querySelector('[data-ic-landscape]');
    if (document.querySelector('.three-card-reading')) return true;
    if (free && !Array.from(free.querySelectorAll('[data-result]')).some(visible)) return true;
    if (celtic && celtic.dataset.stage !== 'explore') return true;
    return !!iching && !Array.from(iching.querySelectorAll('[data-ic-result]')).some(visible);
  };
  const excludedPath = /(?:^|\/)(?:checkouts?|orders|thank_you|thank-you|post-purchase|account)(?:\/|$)/i.test(location.pathname);
  const blocked = () => document.hidden || excludedPath || unfinishedTool() ||
    Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"], [role="dialog"], [aria-busy="true"]')).some(el => el !== dialog && visible(el)) ||
    document.activeElement?.matches('input,textarea,select,[contenteditable="true"]');
  const suppressed = () => readLocal(subscribedKey) === 'true' || readSession(shownKey) === 'true' || Number(readLocal(cooldownKey)) > Date.now();
  let shown = false, returnFocus = null;
  const loadArt = () => {
    const image = root.querySelector('[data-offer-image]');
    if (!dialog.open || !image || image.getAttribute('src') || !matchMedia('(min-width: 651px)').matches) return;
    image.src = image.dataset.src;
    image.addEventListener('error', () => { image.hidden = true; }, { once: true });
  };
  function open(force = false) {
    if (dialog.open || (!force && (shown || suppressed() || blocked()))) return false;
    if (Array.from(document.querySelectorAll('dialog[open]')).some(el => el !== dialog)) return false;
    returnFocus = document.activeElement;
    launcher.hidden = false;
    dialog.showModal();
    loadArt();
    shown = true;
    if (!preview) {
      writeSession(shownKey, 'true');
      if (!succeeded) writeLocal(cooldownKey, Date.now() + 7 * 86400 * 1000);
    }
    root.querySelector('#WelcomeOfferTitle')?.focus({ preventScroll: true });
    return true;
  }
  window.addEventListener('resize', loadArt, { passive: true });
  launcher.addEventListener('click', () => open(true));
  const rememberDismissal = () => {
    if (!preview && !succeeded) writeLocal(cooldownKey, Date.now() + 7 * 86400 * 1000);
  };
  root.querySelectorAll('[data-offer-close]').forEach(button => button.addEventListener('click', () => { rememberDismissal(); dialog.close(); }));
  dialog.addEventListener('cancel', rememberDismissal);
  dialog.addEventListener('close', () => {
    rememberDismissal();
    if (returnFocus?.isConnected && !returnFocus.hidden) returnFocus.focus({ preventScroll: true });
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const box = dialog.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) { rememberDismissal(); dialog.close(); }
  });
  if (submitButton) {
    let submitting = false;
    const idleLabel = submitButton.textContent;
    form.addEventListener('submit', event => {
      if (preview || submitting) { event.preventDefault(); return; }
      if (!form.reportValidity()) { event.preventDefault(); return; }
      submitting = true;
      submitButton.disabled = true;
      submitButton.textContent = submitButton.dataset.submittingLabel || idleLabel;
      form.setAttribute('aria-busy', 'true');
    });
    window.addEventListener('pageshow', () => { submitting = false; if (!preview) submitButton.disabled = false; submitButton.textContent = idleLabel; form.removeAttribute('aria-busy'); });
  }
  if (succeeded) {
    writeLocal(subscribedKey, 'true');
    open(true);
    return;
  }
  if (failed) { open(true); return; }
  if (preview) { launcher.hidden = false; return; }
  if (suppressed() || excludedPath) return;

  let visibleMs = Math.max(0, Math.min(30000, Number(readSession(dwellKey)) || 0));
  let lastTick = performance.now();
  const timer = setInterval(() => {
    const now = performance.now();
    if (!document.hidden) visibleMs = Math.min(30000, visibleMs + Math.max(0, Math.min(now - lastTick, 1500)));
    lastTick = now;
    writeSession(dwellKey, Math.round(visibleMs));
    if (visibleMs >= 30000 && open()) clearInterval(timer);
    else if (suppressed()) clearInterval(timer);
  }, 1000);
  document.addEventListener('visibilitychange', () => { lastTick = performance.now(); });
  window.addEventListener('storage', event => {
    if ((event.key === subscribedKey || event.key === cooldownKey) && suppressed()) {
      clearInterval(timer);
      if (dialog.open) dialog.close();
      launcher.hidden = true;
    }
  });
})();
